import { actions } from '../constants'

const getActions = ({ status,
                      isMobile,
                      includeIcons = true,
                      isInfected = false,
                      canReUpload = false,
                      canSendRequest = false
  }) => {
  const actionKeysByStatus = [
    status === 'Approved' && 'viewSignature',
    isInfected && canReUpload && 'reupload',
    !isInfected && 'download',
    canSendRequest && 'sendRequest',
    'delete',
    status === 'Internal' ? 'share' : 'viewConversation'
  ];

  const actionsByStatus = actionKeysByStatus
    .filter(actionKey => actions[actionKey])
    .map(actionKey => ({ id: actionKey, ...actions[actionKey], icon: includeIcons ? icon : null }));

  const threshold = isMobile ? 1 : 2;
  const [buttons, dropdown] = [actionsByStatus.slice(0,threshold), actionsByStatus.slice(threshold)];

  return { buttons, dropdown }
}

export default getActions;

